import { observer } from 'mobx-react-lite'
import { ExpressionFilter } from '@/features/legends/filters/components/ExpressionFilter'
import type { ExpressionEditorViewModel } from '@/features/legends/filters/types/ExpressionEditorViewModel'

export interface ExpressionFilterContainerProps {
  vm: ExpressionEditorViewModel
  isDisabled?: boolean
  testId?: string
}

export const ExpressionFilterContainer = observer(
  function ExpressionFilterContainer({
    vm,
    isDisabled,
    testId,
  }: ExpressionFilterContainerProps) {
    return (
      <ExpressionFilter
        value={vm.exprDraft}
        onChange={vm.setExprDraft}
        onBlur={vm.commitExpr}
        isDisabled={isDisabled}
        testId={testId && `${testId}-formula`}
      />
    )
  },
)
